import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom'

import { AppLinks } from 'enviroment/AppLinks'
import useAppRootLogic from './hooks/useAppRootLogic'
import PageLayout from 'components/PageLayout/PageLayout'

import StartPage from 'pages/StartPage/StartPage'
import WaitingPage from 'pages/WaitingPages/WaitingPage'
import ErrorPage from 'pages/ErrorPage/ErrorPage'
import FailPage from 'pages/FailPage/FailPage'
import BasicInfoForm from 'pages/BasicInfoForm/BasicInfoForm'
import ExtendedInfoForm from 'pages/ExtendedInfoForm/ExtendedInfoForm'
import CancelApplicationPage from 'pages/CancelApplicationPage/CancelApplicationPage'
import ProductPage from 'pages/ProductPage/ProductPage'
import AddressInfoForm from 'pages/AddressInfoForm/AddressInfoForm'
import BankVerificationPage from 'pages/BankVerificationPage/BankVerificationPage'
import BankVerificationWaitingPage from 'pages/WaitingPages/BankVerificationWaitingPage'
import ContractSigningPage from 'pages/ContractSigningPage/ContractSigningPage'
import SessionEndPage from 'pages/SessionEndPage/SessionEndPage'
import SuccessPage from 'pages/SuccessPage/SuccessPage'
import RetentionPage from 'pages/RetentionPage/RetentionPage'
import ChooseIdentityMethodPage from 'pages/ChooseIdentityMethodPage/ChooseIdentityMethodPage'
import MObywatelIdentityPage from 'pages/MObywatelIdentityPage/MObywatelIdentityPage'
import { ChooseIdentityMethodTypes } from 'pages/ChooseIdentityMethodPage/ChooseIdentityMethodPageProps'
import MObywatelExtendedInfoForm from 'pages/MObywatelExtendedInfoForm/MObywatelExtendedInfoForm'
import ClientPeselReservedPage from 'pages/ClientPeselReservedPage/ClientPeselReservedPage'
import VideoVerificationBasicInfoFormPage from 'pages/VideoVerificationPages/VideoVerificationForms/VideoVerificationBasicInfoFormPage'
import VideoVerificationAddressInfoFormPage from 'pages/VideoVerificationPages/VideoVerificationForms/VideoVerificationAddressInfoFormPage'
import VideoVerificationErrorPage from 'pages/VideoVerificationPages/VideoVerificationErrorPage/VideoVerificationErrorPage'
import VideoVerificationBackFromPartnerPage from 'pages/VideoVerificationPages/VideoVerificationBackFromPartnerPage/VideoVerificationBackFromPartnerPage'
import VideoVerificationStartPage from 'pages/VideoVerificationPages/VideoVerificationStartPage/VideoVerificationStartPage'
import CollectPersonalIdPage from 'pages/CollectPersonalIdPage/CollectPersonalIdPage'


/**
 * Podstawowy komponent obsługujący routing w aplikacji
 */
const AppRoot = (): JSX.Element => {
  
  useAppRootLogic()

  return (
    <Routes>
        <Route path={AppLinks.home} element={<PageLayout />} >
            <Route path={AppLinks.start} element={<StartPage />} />
            <Route path={AppLinks.waiting} element={<WaitingPage />} />
            <Route path={AppLinks.error} element={<ErrorPage />} />
            <Route path={AppLinks.houston} element={<ErrorPage />} />
            <Route path={AppLinks.sessionEnd} element={<SessionEndPage />} />
            
            <Route path={AppLinks.productPage} element={<ProductPage />} />
            <Route path={AppLinks.retention} element={<RetentionPage />} />
            <Route path={AppLinks.fail} element={<FailPage />} />
            <Route path={AppLinks.success} element={<SuccessPage />} />
            <Route path={AppLinks.cancel} element={<CancelApplicationPage />} />
            <Route path={AppLinks.bmverify} element={<BankVerificationPage />} />
            <Route path={AppLinks.bmWaiting} element={<BankVerificationWaitingPage />} />
            <Route path={AppLinks.chooseVerificationMethod} element={<ChooseIdentityMethodPage chooseIdentityMethodType={ChooseIdentityMethodTypes.VERIFICATION} />} />
            <Route path={AppLinks.contractSigning} element={<ContractSigningPage />} />
            <Route path={AppLinks.clientPeselReservedPage} element={<ClientPeselReservedPage />} />
    

            <Route path={AppLinks.basicInfoForm} element={<BasicInfoForm />} />
            <Route path={AppLinks.extendedInfoForm} element={<ExtendedInfoForm />} />
            <Route path={AppLinks.addressInfoForm} element={<AddressInfoForm />} />
            <Route path={AppLinks.trastiCollectPersonalIdForm} element={<CollectPersonalIdPage />} />
            <Route path={AppLinks.mObywatelExtendedInfoForm} element={<MObywatelExtendedInfoForm />} />
            <Route path={AppLinks.chooseIdentityMethod} element={<ChooseIdentityMethodPage chooseIdentityMethodType={ChooseIdentityMethodTypes.IDENTITY} />} />
            <Route path={AppLinks.mObywatelIdentityMethod} element={<MObywatelIdentityPage chooseIdentityMethodType={ChooseIdentityMethodTypes.IDENTITY} />} />
            <Route path={AppLinks.mObywatelVerificationMethod} element={ <MObywatelIdentityPage chooseIdentityMethodType={ChooseIdentityMethodTypes.VERIFICATION} />} />
            
            <Route path={AppLinks.videoVerificationStartIdentificationPage} element={<VideoVerificationStartPage chooseIdentityMethodType={ChooseIdentityMethodTypes.IDENTITY} /> } />
            <Route path={AppLinks.videoVerificationStartVerificationPage} element={<VideoVerificationStartPage chooseIdentityMethodType={ChooseIdentityMethodTypes.VERIFICATION}/> } />
            <Route path={AppLinks.videoVerificationIdentificationErrorPage} element={<VideoVerificationErrorPage chooseIdentityMethodType={ChooseIdentityMethodTypes.IDENTITY} /> } />
            <Route path={AppLinks.videoVerificationVerificationErrorPage} element={<VideoVerificationErrorPage chooseIdentityMethodType={ChooseIdentityMethodTypes.VERIFICATION}/> } />
            <Route path={AppLinks.videoVerificationBasicInfoForm} element={<VideoVerificationBasicInfoFormPage />} />
            <Route path={AppLinks.videoVerificationAddressInfoForm} element={<VideoVerificationAddressInfoFormPage />} />
            <Route path={AppLinks.videoVerificationBackFromPartner} element={<VideoVerificationBackFromPartnerPage />} />

            <Route path="*" element={<Navigate to="/" replace />} /> {/* Każdy inny URL */}
        </Route>
    </Routes>
  )
}

export default AppRoot;